import { API_URLS } from '$constants/apis';
import type { NETWORK_CONFIG } from '@brahma/utils';
import { POST } from '@brahma/utils';

export const SIGN_IN_URL_POST_CONFIG: NETWORK_CONFIG = {
  url: API_URLS.logInUrl,
  options: { method: POST }
};

export const COUNTRY_CODE = 'countryCode';
export const COUNTRY_FLAG_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/country/#{${COUNTRY_CODE}}.svg`;
